<section class="contato" id="contato" [class.contraste]="this.contrasteAtivo">
    <div class="contato__faleConosco">
        <h3 class="section-title">Fale Conosco</h3>
        <p>Você sonha, nós realizamos</p>
        <!-- action="../../services/enviar-email.php" -->
        <form class="contato__faleConosco-form" #form="ngForm" novalidate="false" (submit)="enviarEmail(form)">
            <p>
                <label for="Nome">Nome: <span class="campo-obrigatorio">*</span></label>
                <input type="text" name="Nome" id="Nome" placeholder="Ex: Angela Maria da Silva" required title="Nome..." class="contato__campo-input" #Nome="ngModel" ngModel>
            </p>
            <p>
                <label for="Email">E-mail: <span class="campo-obrigatorio">*</span></label>
                <input type="email" [email]="true" name="Email" id="Email" placeholder="abcdef@exemplo.com" required title="E-mail..." class="contato__campo-input" #Email="ngModel" ngModel>
            </p>
            <p>
                <label for="Telefone">Telefone: <span class="campo-obrigatorio">*</span></label>
                <input type="text" name="Telefone" id="Telefone" mask="(00) 0.0000-0000" placeholder="Ex: (11) 95346-3376" required title="Telefone..." class="contato__campo-input" #Telefone="ngModel" ngModel>
                <!-- (keyup)="verificaTelefone(telefone)" -->
            </p>
            <p>
                <label for="Assunto">Assunto: </label>
                <input name="Assunto" id="Assunto" placeholder="Assunto..." title="Assunto..." class="contato__campo-input" #Assunto="ngModel" ngModel>
            </p>
            <p>
                <label for="Mensagem">Mensagem: <span class="campo-obrigatorio">*</span></label>
                <textarea name="Mensagem" id="Mensagem" placeholder="Sua mensagem aqui..." required title="Mensagem..." class="contato__campo-input contato__campo-input--textarea" #Mensagem="ngModel" ngModel></textarea>
            </p>
            <div class="contato__faleConosco--footer">
                <span *ngIf="form.invalid && form.touched">Existem um ou mais campos obrigatórios !!</span>
                <button type="submit" class="btn-enviarMensagem" [class.disabled]="form.invalid" [disabled]="form.invalid" title="Enviar Mensagem">Enviar</button>
            </div>
        </form>
    </div>
    <div class="contato__comoChegar">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.1052147801156!2d-46.65582238502217!3d-23.56466438468128!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce59c7d3a04d29%3A0xd7035ad82107a00d!2sAv.%20Paulista%2C%201159%20-%20Jardim%20Paulista%2C%20S%C3%A3o%20Paulo%20-%20SP%2C%2003103-003!5e0!3m2!1spt-BR!2sbr!4v1584029194495!5m2!1spt-BR!2sbr"
            width="600" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0" class="img-mapa"></iframe>

    </div>
</section>